import {
  patchState,
  signalStore,
  withHooks,
  withMethods,
  withState,
} from '@ngrx/signals';
import { BaseState, withCrudOperations } from '../crud.state';
import { UserService } from '../../services/user/user.service';
import { User, UserWorkspace } from '../../models/user';
import { inject } from '@angular/core';
import { IndicatorService } from '../../services/indicator/indicator.service';
import { withLogging } from '../features/logger.feature';
import { MailingService } from '../../services/mailing.service';

export type UserState = BaseState<User>;

export const initialState: UserState = {
  items: {},
  loading: false,
  initialized: false,
  itemsLoaded: false,
  version: 0,
  lastPersistedId: '',
  trigger: undefined,
  selectedId: '',
  selection: [],
  entityType: 'User',
  entityLabel: 'Nutzer:innen',
  filter: {
    query: '',
    category: [],
    tags: undefined,
    products: undefined,
    published: null,
    locked: null,
    ids: undefined,
  },
  events: {
    add: ['sendUserMail'],
    update: ['sendUserMail'],
    delete: [],
    socket: [],
  },
};

export const UserStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withCrudOperations<User>(UserService),
  withLogging(initialState.entityType),
  withMethods(
    (
      store,
      userService = inject(UserService),
      mailingService = inject(MailingService)
    ) => ({
      resetPassword(password: string, userId: string) {
        userService.resetPassword(password, userId);
      },
      changeCommune(user: User) {
        userService.changeCommune(user);
      },
      async loadByCommune(communeId: string) {
        return await userService.getItemsByCommune(communeId);
      },
      async fetchById(userId: string) {
        return await userService.getById(userId);
      },
      sendForgotPasswordMail(username: string) {
        mailingService.sendForgotPasswordMail(username).subscribe();
      },
      sendNewUserMail(user: User) {
        console.log('SEND NEW USER MAIL');
        mailingService.sendNewUserMail(user).subscribe((res: any) => {
          console.log('newusermail sent', res);
        });
      },
      sendTestMail(user: User) {
        mailingService.sendNewUserMail(user).subscribe();
      },
      findByWorkspaceId(workspaceId: string) {
        return Object.values(store.items()).filter((user: User) => {
          const workspaceIds = user.workspaces.map(
            (w: UserWorkspace) => w.workspace
          );
          return workspaceIds.includes(workspaceId);
        });
      },
    })
  ),
  withHooks({
    onInit({ loadAllItemsByPromise }) {
      loadAllItemsByPromise();
    },
    onDestroy() {
      console.log('on destroy');
    },
  })
);
